import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Tooltip } from 'next-common-lib';
import i18n from 'i18n';
import DeleteButton from 'components/Common/Buttons/DeleteButton';
import * as departmentActions from 'redux/ducks/Department/DepartmentDucks';
import * as wizardActions from 'redux/ducks/common/wizardDuck';

export const InputDepartment = () => {
  const dispatch = useDispatch();

  const departmentList = useSelector(state => state.department.departmentList);
  const adminVo = useSelector(state => state.adminInfo.adminVo);
  return (
    <div>
      <Button
        componentType="normal"
        label={i18n.t('BTY_W_T_ADD_DEPT_INFO')}
        className="add"
        iconInfo={{ className: 'ic-plus ', size: 'sm' }}
        disabled={departmentList?.length === 20}
        tabIndex={0}
        onClick={() => {
          dispatch(wizardActions.openPopup({}));
        }}
      />
      {departmentList?.map((item, idx) => {
        return (
          <div className="view-box" key={idx}>
            <Tooltip componentType="move" label={[`${item.deptNm}`]} placement="bottom">
              <div className="view-box-content">
                <div className="view-option">
                  <div className="tit">
                    <div className="pt-badge round size-min bg-c200">
                      <span className="text">{i18n.t('BTY_W_T_CODE')}</span>
                    </div>
                    <p className="sub-main-text">{item.deptCd}</p>
                  </div>
                </div>

                <p className="main-text">{item.deptNm}</p>
                <p className="main-text">{item.enDeptNm}</p>
              </div>
            </Tooltip>
            <DeleteButton
              handleOnclick={() =>
                dispatch(
                  departmentActions.deleteDepartment({
                    compCd: adminVo.compCd,
                    deptCd: item.deptCd,
                    uprDeptCd: 'TOP',
                  }),
                )
              }
            />
          </div>
        );
      })}
    </div>
  );
};

InputDepartment.propTypes = {};
InputDepartment.defaultProps = {};
export default InputDepartment;
